<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="EPI">Observe perpetually … Observe my own despondency. By that means it becomes serviceable. Or so I hope.</p>
<p class="EPS">—<span class="ePub-I">The Diary of Virginia Woolf</span>, Volume V</p>
<p class="EPIF">All my watercolors fade to black.</p>
<p class="EPS">—Annie Lennox, <span class="ePub-I">Pavement Cracks</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5cdf623a